import React from 'react'
import {
  FormControl,
  FormControlLabel,
  Box,
  TextField,
  Button,
  Checkbox,
} from '@mui/material'
import '../../../styles/pages.css'

function CreateEnvironment({
  onSubmit,
  label,
  updateName,
  updateVerified,
}: {
  onSubmit: React.FormEventHandler<HTMLElement>
  label: string
  updateName: React.Dispatch<React.SetStateAction<string>>
  updateVerified: React.Dispatch<React.SetStateAction<boolean>>
}) {
  const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateName(e.target.value)
  }
  const onVerifiedChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => {
    updateVerified(checked)
  }

  return (
    <FormControl>
      <Box component="form" sx={{ width: '70ch' }} onSubmit={onSubmit}>
        <Box m={2}>
          <TextField
            label={label}
            placeholder={label}
            variant="outlined"
            onChange={onNameChange}
            fullWidth
            inputProps={{
              'aria-label': label,
            }}
          />
        </Box>
        <Box m={2}>
          <FormControlLabel
            control={<Checkbox onChange={onVerifiedChange} />}
            label="Is Verified"
          />
        </Box>
        <Box m={2}>
          <Button onClick={onSubmit} variant="outlined" color="secondary">
            Create!
          </Button>
        </Box>
      </Box>
    </FormControl>
  )
}

export default CreateEnvironment
